class OtpRequest{
    constructor(){
        this.userId = null;
        this.user_Id = null;
        this.otp = null;
        this.type=null;
        this.oldPassword = null;
        this.newPassword =null;
        this.fcmToken = null;
    }
}
export default OtpRequest;